import * as T from 'io-ts';
import { NonEmptyString } from 'io-ts-types';
import { fromNullable } from 'io-ts-types/lib/fromNullable';
export const CardT = T.type({
    heading: NonEmptyString,
    green_text: NonEmptyString,
    amber_text: NonEmptyString,
    red_text: NonEmptyString,
    deleted: fromNullable(T.boolean, false),
});
